import React, { Component } from 'react'

const Map = class Map extends Component {
  constructor(props) {
    super(props)

    this.init = this.init.bind(this)
    this.googleMap = this.googleMap.bind(this)
    this.mergeOptions = this.mergeOptions.bind(this)
  }

  componentDidMount() {
    if (!window.google) {
      const script = document.createElement('script');
      script.async = true;
      script.defer = true;
      script.src = "//maps.googleapis.com/maps/api/js?key=AIzaSyA2x3rfhmNK4DBawFUnWq4UxvttHNjkeIE"
      script.addEventListener('load', () => {
        this.init();
      })

      document.querySelector('.goo-map').appendChild(script)
    } else
      this.init()
  }

  init() {        
    this.googleMap('.goo-map', {
      markers: [ {
        marker: '/static/images/map-marker.svg',
        width: 60,
        height: 60,
        top: 60,
        left: 0,
        lat: 52.5785483,
        lng: 1.121296,
        goo: 'dxUUp7LMXW32'
      }]
    })
  }

  mergeOptions(userOptions, options) {
    Object.keys(userOptions).forEach(function (key) {
        options[key] = userOptions[key]
    })
  }

  googleMap(selector, userOptions) {
    // Merge passed options with defaults
    var element = document.querySelector(selector)

    if (!element)
        return;

    var
      options = {
          lat: element.getAttribute('data-lat')
        , lng: element.getAttribute('data-lng')
        , goo: element.getAttribute('data-goo')
        , zoom: element.getAttribute('data-zm') || 10
        , markers: []
        , width: 2560
        , height: 1400
        , minHeight: 200
        , maxHeight: 760
      };

    if (userOptions) {
      this.mergeOptions(userOptions, options)
    }
    
    (window.redraw = function (map, point) {
      var
          vW = window.innerWidth
        , vH = window.innerHeight
        , rt = options.width / options.height
        , mW = element.parentNode.clientWidth
        , mH = Math.max(Math.min((mW / rt), options.maxHeight), options.minHeight);

      //element.style.height = mH+'px';
      element.style.height = '100%';

      if (map)
          map.setCenter(point);
    })();

    var 
      point = new google.maps.LatLng(options.lat, options.lng),
      MY_MAPTYPE_ID = 'custom_style',
      MY_COLOURS = {
          white: '#ffffff',
          black: '#212328',
          dark: '#231F20',
          mid: '#e4e4e4',
          light: '#ededeb',
          blue: '#cadce7',
          green: '#c2d1c6'
      },
      featureOpts = [
      {
          "featureType": "administrative",
          "elementType": "labels.text.fill",
          "stylers": [
              {
                  "color": "#444444"
              }
          ]
      },
      {
          "featureType": "landscape",
          "elementType": "all",
          "stylers": [
              {
                  "color": "#f2f2f2"
              }
          ]
      },
      {
          "featureType": "poi",
          "elementType": "all",
          "stylers": [
              {
                  "visibility": "off"
              }
          ]
      },
      {
          "featureType": "road",
          "elementType": "all",
          "stylers": [
              {
                  "saturation": -100
              },
              {
                  "lightness": 45
              }
          ]
      },
      {
          "featureType": "road",
          "elementType": "geometry",
          "stylers": [
              {
                  "gamma": "1.00"
              },
              {
                  "lightness": "-20"
              }
          ]
      },
      {
          "featureType": "road",
          "elementType": "all",
          "stylers": [
              {
                  "visibility": "simplified"
              }
          ]
      },
      {
          "featureType": "road",
          "elementType": "labels",
          "stylers": [
              {
                  "visibility": "off"
              }
          ]
      },
      {
          "featureType": "transit",
          "elementType": "all",
          "stylers": [
              {
                  "visibility": "off"
              }
          ]
      },
      {
          "featureType": "water",
          "elementType": "all",
          "stylers": [
              {
                  "visibility": "on"
              },
              {
                  "hue": "#ff0000"
              }
          ]
      },
      {
          "featureType": "water",
          "elementType": "geometry",
          "stylers": [
              {
                  "visibility": "on"
              },
              {
                  "color": "#2e485b"
              },
              {
                  "gamma": "2"
              }
          ]
      },
      {
          "featureType": "water",
          "elementType": "labels.text",
          "stylers": [
              {
                  "visibility": "on"
              },
              {
                  "color": "#ffffff"
              }
          ]
      }],
      myMapOptions = {
          zoom: parseInt(options.zoom),
          center: point,
          mapTypeControl: false,
          mapTypeId: MY_MAPTYPE_ID,
          draggable: true,
          scrollwheel: false,
          zoomControl: true,
          fullscreenControl: false,
          zoomControlOptions: {
              position: google.maps.ControlPosition.RIGHT_BOTTOM
          },
          streetViewControl: false
      },
      map = new google.maps.Map(element, myMapOptions),
      customMapType = new google.maps.StyledMapType(featureOpts);

      map.mapTypes.set(MY_MAPTYPE_ID, customMapType);

      [].forEach.call(options.markers, function (item, index) {
          var image = {
              url: item.marker,
                  size: new google.maps.Size(
                      item.width,
                      item.height),
                  scaledSize: new google.maps.Size(
                      item.width / 2,
                      item.height / 2),
                  anchor: new google.maps.Point(
                      item.left,
                      item.top
                      )
              },
              marker = new google.maps.Marker({
                  draggable: false,
                  icon: image,
                  map: map,
                  position: item.lat && item.lng ? new google.maps.LatLng(item.lat, item.lng) : point
              });

          if (item.goo)
              google.maps.event.addListener(marker, 'click', function () {
                  var winUrl = item.goo.indexOf('http') === 0 || item.goo.indexOf('/') === 0 ? item.goo : 'https://goo.gl/maps/' + item.goo;

                  window.open(winUrl, '_self');
              });
      });

      window.addEventListener('resize', function () { window.redraw(map, point); });
  }

  render() {
    return (
      <div
        className="goo-map"
        data-mkr="google"
        data-lat="52.5785483"
        data-lng="1.121296"
        data-goo="kPKxccYKuY72"
        data-zm="10">        
      </div>       
    )
  }
}

export default Map


// WEBPACK FOOTER //
// ./src/components/map.js